import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CreateWaveGroupSearchField from "./CreateWaveGroupSearchField";
export default function CreateWaveInlineGroupSearch(t0) {
  const $ = _c(11);
  const {
    defaultLabel,
    disabled,
    hasUnsavedGroup,
    selectedGroup,
    allowGroupClear: t1,
    onSelect
  } = t0;
  const allowGroupClear = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== hasUnsavedGroup) {
    t2 = hasUnsavedGroup && <div className="tw-rounded-lg tw-border tw-border-solid tw-border-primary-500/20 tw-bg-primary-500/5 tw-p-3"><p className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-primary-300">Unsaved group</p><p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-300">Choosing another group will discard this unsaved group.</p></div>;
    $[0] = hasUnsavedGroup;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== allowGroupClear || $[3] !== defaultLabel || $[4] !== disabled || $[5] !== onSelect || $[6] !== selectedGroup) {
    t3 = <CreateWaveGroupSearchField label={"Search groups\u2026"} defaultLabel={defaultLabel} disabled={disabled} selectedGroup={selectedGroup} allowClear={allowGroupClear} onSelect={onSelect} />;
    $[2] = allowGroupClear;
    $[3] = defaultLabel;
    $[4] = disabled;
    $[5] = onSelect;
    $[6] = selectedGroup;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="tw-space-y-3">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}